import { useState, useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import { fetcher } from 'app/http';
import qs from 'qs';
import { useAppDispatch } from 'app/hooks';
import styles from './EditEmailPageData.module.scss';
import { validateEmail } from 'common/helpers/valdiation';
import { isNullOrWhiteSpace } from 'common/helpers/string';
import { formProgression, formError } from 'common/helpers/Gtm';
import classnames from 'classnames/bind';
import TagManager from 'react-gtm-module';
interface Props {
  PageData?: any;
  Model?: any;
  layoutModel?: any;
  handleClick: Function;
  handleClickEmailConfirmation: Function;
  setEditEmailConfirmationResponseData: Function;
}

const EditEmailPageData = ({
  PageData,
  Model,
  handleClick,
  setEditEmailConfirmationResponseData,
  handleClickEmailConfirmation,
}: Props) => {
  const [content, setContentPage] = useState<any>({ Model, PageData });

  const getPathnameFromUrl = (url: string) => {
    const link = new URL(url);
    return link.pathname + link.search;
  };

  const [email, setEmail] = useState(content?.Model?.FormModel.Email);

  const [isPageReloaded, setIsPageReloaded] = useState(false);

  const [confirmEmail, setConfirmEmail] = useState(
    content?.Model?.FormModel.ConfirmEmail,
  );

  const [enablebutton, setEnablebutton] = useState(false);
  function editEmail(e: any) {
    setEmail(e.target.value);
    if (validateEmail(e.target.value)) {
      if (e.target.value === confirmEmail) {
        setEnablebutton(true);
      } else {
        setEnablebutton(false);
      }
    } else {
      setEnablebutton(false);
    }
  }

  function editConfirmEmail(e: any) {
    setConfirmEmail(e.target.value);
    if (validateEmail(e.target.value)) {
      if (e.target.value === email) {
        setEnablebutton(true);
      } else {
        setEnablebutton(false);
      }
    } else {
      setEnablebutton(false);
    }
  }

  function cancelEditEmail(e: any) {
    handleClick(false);
  }

  useEffect(() => {
    setContentPage({ Model, PageData });
  }, [Model, PageData]);

  const formSubmit = async (e: any) => {
    e.preventDefault();
    try {
      const response = await fetcher.post(
        Model.SendConfirmationCodePageUri,

        qs.stringify({
          'FormModel.Email': email,
          'FormModel.ConfirmEmail': confirmEmail,
          'FormModel.TimezoneOffsetInMinutes':
            content?.Model?.FormModel.TimezoneOffsetInMinutes,
        }),
      );
      if (response && response.data && response.data.RedirectUrl) {
        const responseConfirmData = await fetcher.get(
          getPathnameFromUrl(response.data.RedirectUrl),
        );
        if (responseConfirmData && responseConfirmData.data) {
          setEditEmailConfirmationResponseData(responseConfirmData.data);
          handleClickEmailConfirmation(true);
          handleClick(false);
        }
      } else if (response && response.data) {
        setContentPage({
          PageData: response?.data?.PageData,
          Model: response?.data?.Model,
        });
        handleClick(true);
        setIsPageReloaded(true);
      }
    } catch (err) {
      console.error(err);
    }
  };

  return (
    <form onSubmit={formSubmit}>
      <div className="Modal-content is-active">
        <div className="Grid Grid--gutterA Grid--gutter-sm-Bz">
          <div className="Grid-cell  u-lg-size1of1 u-paddingBz">
            <h3 className="Heading Heading-h3--portal u-marginBz">
              {content?.PageData?.PageHeader}{' '}
            </h3>
            <p className="Text--small u-marginTxxsm">
              {content?.PageData?.EmailInfoText}
            </p>
          </div>
          <div className="Grid-cell  u-lg-size1of2">
            <label className="Label Form-label">
              {content?.PageData?.EmailAddressLabel}
            </label>
            <div className="Input Input-button--after data-hj-suppress">
              <input
                type="text"
                value={content?.Model?.Email}
                onChange={(e) => editEmail(e)}
                onBlur={(e) =>
                  formProgression(e, 'Profile Email form', 'EmailAddress')
                }
              />
            </div>
            {isPageReloaded &&
              (isNullOrWhiteSpace(content?.Model?.FormModel.Email) ||
                !validateEmail(content?.Model?.FormModel.Email)) && (
                <span className="text-danger">
                  {content?.PageData?.InvalidEmailErrorMessage}
                </span>
              )}
          </div>

          <div className="Grid-cell  u-lg-size1of2">
            <label className="Label Form-label">
              {content?.PageData?.ConfirmEmailAddressLabel}
            </label>
            <div className="Input Input-button--after data-hj-suppress">
              <input
                type="text"
                value={content?.Model?.ConfirmEmail}
                onChange={(e) => editConfirmEmail(e)}
                onBlur={(e) =>
                  formProgression(e, 'Profile Email form', 'ConfirmEmail')
                }
              />
            </div>
            {content?.Model?.ShowEmailsDoNotMatchError && (
              <span className="text-danger">
                {content?.PageData?.EmailsDontMatchErrorMessage}
              </span>
            )}
            {isPageReloaded &&
              (isNullOrWhiteSpace(content?.Model?.FormModel.ConfirmEmail) ||
                !validateEmail(content?.Model?.FormModel.ConfirmEmail)) && (
                <span className="text-danger">
                  {content?.PageData?.InvalidEmailErrorMessage}
                </span>
              )}
          </div>
        </div>
        <div className="Grid Grid--gutterA Grid--gutter-sm-Bz">
          <div className="Grid-cell  u-lg-size1of1">
            <div className="Customerdetails-modalButtons">
              <div className="ButtonBar  ButtonBar--spaceBetween ButtonBar--row-reverse ">
                <button
                  id="BTN_send-verification-code"
                  type="submit"
                  className={enablebutton ? 'Button ' : 'Button is-disabled'}
                >
                  <span>
                    {content?.PageData?.SendVerificationCodeButtonLabel}
                  </span>
                </button>
                <a
                  id="BTN_cancel-edit-email"
                  onClick={(e) => cancelEditEmail(e)}
                  className="Button Button--gray js-modalclose"
                >
                  <span>{content?.PageData?.CancelButtonLabel} </span>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </form>
  );
};

export default EditEmailPageData;
